import UploadApi from "@/api/upload-api";
import OCROrderApi from "@/api/ocr-order-api";

namespace OcrOrder {
    export type ImgFile = UploadApi.IFileDetailView & { url: string }
    export type DetailItem = OCROrderApi.IOcrOrderReceiptItem & { files?: ImgFile[], RowIndex: number }
    export type IOcrOrderListItemWithDetail = OCROrderApi.IOcrOrderListItemWithDetail & {
        Detail: Array<DetailItem>
    }
    export const UploadFiles = {
        /**理货单，货物外观照片 */
        hk_receipt_order_goods: "hk_receipt_order_goods",
        /**明细照片 */
        hk_receipt_info: "hk_receipt_info"
    }
    export const DefaultMpqUnitType = OCROrderApi.PackagingUnit.Reel;
    export function getDateTime(b: NString) {
        if (!b) return '';
        const date = new Date(b);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${year}/${month}/${day} ${hours}:${minutes}`;
    }

    export function oldPackageConvert(packages: OCROrderApi.IReceiptPackagingInfo[]) {
        if (!packages.length) return [] as OCROrderApi.IReceiptPackagingInfo[];
        if (packages.length == 1) {
            // console.error("nochg 1")
            return packages;
        }

        if (packages.length == 2) {
            if (packages[1].PCS == 1) {
                // console.error("nochg 2")
                return packages; //散料，件数只能为1
            }
        }

        var pc = packages.find(e => e.Type != 0);
        var pcs: OCROrderApi.IReceiptPackagingInfo[] = [];
        if (pc) {
            pcs.push(pc);
            var total = Array.sum(packages, e => e.PCS * e.Qty * (e.AsKilo ? 1000 : 1));
            total -= pc.PCS * pc.Qty;
            pcs.push({ PCS: 1, Qty: total, Type: 0, AsKilo: false, AgentOrderDetailReceiptInfoId: 0 });
            return pcs;
        }

        var set = new Set(packages.map(e => e.Qty));
        var qty: Record<number, number> = {};
        for (var p of set) {
            qty[p] = Array.sum(packages.filter(e => e.Qty == p), e => Number(e.PCS));
        }

        var enter = Object.entries(qty);
        enter.sort((a, b) => b[1] - a[1])
        var m = enter[0];
        pc = { PCS: m[1], Qty: Number(m[0]), Type: OCROrderApi.PackagingUnit.Reel, AsKilo: false, AgentOrderDetailReceiptInfoId: 0 };
        pcs.push(pc)
        var total = Array.sum(packages, e => e.PCS * e.Qty * (e.AsKilo ? 1000 : 1));
        total -= pc.PCS * pc.Qty;
        pcs.push({ PCS: 1, Qty: total, Type: 0, AsKilo: false, AgentOrderDetailReceiptInfoId: 0 });

        return pcs;
    }

}
export default OcrOrder